export function Divider() {
  return <div className="border-b border-gray-200" />;
}
